const getVersionFromPackageJson = (): string | undefined => {
  try {
    // In build time, we can access package.json
    const packageJson = require('../../package.json');
    return packageJson.version;
  } catch (error) {
    // In runtime, package.json might not be available
    console.warn(
      'Could not read version from package.json, using fallback version',
    );
    return undefined;
  }
};

export const APP_VERSION = getVersionFromPackageJson();
